import ajax from "../assets/uilt/ajax";

let incident = {
  /**根据ID查询申请记录 */
  getById: (req) => {
    return ajax.get({
      url: "/back/incident/get-by-id",
      param: req.param,
      success: req.success,
    });
  },
  /**分页查询申请记录 */
  getPage: (req) => {
    return ajax.get({
      url: "/back/incident/get-page",
      param: req.param,
      success: req.success,
    });
  },

  /**增加申请记录(渠道充值、提现) */
  addIncident: (req) => {
    return ajax.post({
      url: "/back/incident/add-incident",
      param: req.param,
      success: req.success,
    });
  },
  /**审核渠道充值、提现 */
  disposeIncident: (req) => {
    return ajax.post({
      url: "/back/incident/dispose-incident",
      param: req.param,
      success: req.success,
    });
  },
};

export default incident;
